import React from "react";

const PreviewModal = ({ videoUrl, mobileUrl, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className={`bg-white rounded-lg overflow-hidden ${mobileUrl ? 'w-60' : 'w-full max-w-3xl'}`}>
        <div className="flex justify-between items-center p-4">
          <h2 className="text-xl font-bold">Project Video</h2>
          <button
            className="text-black text-xl font-bold"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="p-4">
          {mobileUrl ? (
            <video
              controls
              src={mobileUrl}
              className="w-full h-auto"
            />
          ) : (
            <video
              controls
              src={videoUrl}
              className="w-full h-auto"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
